import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { PropTypesRepo } from '../functions/_propTypes';

import Div from './Div';
import Icon from './Icon';

const CheckboxInput = styled.input`
  display: none;
`;

const Switch = ({ checked, m, activeColor, inactiveColor, activeShadow, inactiveShadow, isLoading, ...rest }) => (
  <>
    <CheckboxInput type="checkbox" {...rest} />
    <Div
      m={m}
      d="flex"
      align="center"
      justify="center"
      shadow={checked ? activeShadow : inactiveShadow}
      bg={checked ? activeColor : inactiveColor}
      p={{ y: '4px', x: '13px' }}
      rounded="circle"
      style={{ transition: 'transform 0.1s ease-in-out' }}
    >
      {isLoading ? (
        <Icon name="Loading" size="20px" color="white" />
      ) : (
        <Div
          style={{
            transition: 'transform 0.1s ease-in-out',
            transform: checked ? 'translateX(50%)' : 'translateX(-50%)',
          }}
          h="16px"
          w="16px"
          shadow="4"
          bg="white"
          rounded="circle"
        />
      )}
    </Div>
  </>
);

Switch.propTypes = {
  checked: PropTypes.bool,
  m: PropTypesRepo.m,
  activeColor: PropTypesRepo.bg,
  inactiveColor: PropTypesRepo.bg,
  activeShadow: PropTypesRepo.shadow,
  inactiveShadow: PropTypesRepo.shadow,
  isLoading: PropTypes.bool,
  cursor: PropTypesRepo.cursor,
};

Switch.defaultProps = {
  cursor: 'pointer',
  m: { r: '16px' },
  activeColor: 'info700',
  inactiveColor: 'gray500',
  activeShadow: '4',
  inactiveShadow: '0',
  checked: undefined,
  isLoading: false,
};

export default Switch;
